import React from 'react';
import { Calendar, ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

interface BlogPost {
  title: string;
  slug: string;
  excerpt: string;
  published_at: string;
}

interface BlogCardProps {
  post: BlogPost;
  icon?: React.ReactNode;
  iconAlt?: string;
}

export const BlogCard: React.FC<BlogCardProps> = ({ post, icon, iconAlt }) => {
  const formattedDate = new Date(post.published_at).toLocaleDateString('he-IL', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden">
      {icon && (
        <div 
          className="flex justify-center p-6 bg-gray-50"
          role="img"
          aria-label={iconAlt}
        >
          {icon}
        </div>
      )}
      <div className="p-6">
        <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
          <Calendar className="w-4 h-4" />
          <span>{formattedDate}</span>
        </div>
        
        <h3 className="text-xl font-bold text-gray-800 mb-3">
          {post.title}
        </h3>
        
        <p className="text-gray-600 mb-4">
          {post.excerpt}
        </p>

        <Link 
          to={`/blog/${post.slug}`}
          className="inline-flex items-center text-blue-600 hover:text-blue-800 transition-colors"
        >
          קראו עוד
          <ChevronLeft className="w-4 h-4 mr-1" />
        </Link>
      </div>
    </div>
  );
};